/* Chloeya lazy product-gallery video.
   Parks every <video data-media-id> before the browser can fetch it, then
   releases it (and autoplays) on ANY of three independent triggers:
     1. IntersectionObserver - the slide enters the viewport
     2. the slide gains Swiper's active/visible class
     3. a pointer/click lands inside the slide
   Three triggers because IntersectionObserver does not fire while the
   document is hidden; the class and pointer triggers do not depend on it.
   Must be loaded in <head> WITHOUT defer so it runs before the body parses. */
(function () {
  'use strict';
  var SEL = 'video[data-media-id]';
  var ACTIVE = /swiper-slide-(active|visible|next|prev)/;

  function park(v) {
    if (!v || v.__chloeyaLive) return;
    if (!v.__chloeyaParked) {
      v.__chloeyaParked = true;
      v.removeAttribute('autoplay');
      try { v.autoplay = false; } catch (e) {}
      v.setAttribute('preload', 'none');
      try { v.preload = 'none'; } catch (e) {}
    }
    var s = v.getElementsByTagName('source');
    for (var i = 0; i < s.length; i++) {
      var src = s[i].getAttribute('src');
      if (src) {
        s[i].setAttribute('data-chloeya-src', src);
        s[i].removeAttribute('src');
      }
    }
  }

  function wake(v) {
    if (!v || v.__chloeyaLive) return;
    v.__chloeyaLive = true;
    var s = v.getElementsByTagName('source');
    for (var i = 0; i < s.length; i++) {
      var src = s[i].getAttribute('data-chloeya-src');
      if (src) {
        s[i].setAttribute('src', src);
        s[i].removeAttribute('data-chloeya-src');
      }
    }
    v.setAttribute('preload', 'metadata');
    try { v.preload = 'metadata'; } catch (e) {}
    try { v.muted = true; } catch (e) {}
    try { v.load(); } catch (e) {}
    var p;
    try { p = v.play(); } catch (e) {}
    if (p && p['catch']) { p['catch'](function () {}); }
  }

  /* ---- Phase 1: park at parse time, before media resource selection runs ---- */
  if (typeof MutationObserver === 'function') {
    var parkObserver = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.tagName === 'VIDEO') {
            if (n.hasAttribute('data-media-id')) park(n);
          } else if (n.tagName === 'SOURCE') {
            var pv = n.parentNode;
            if (pv && pv.tagName === 'VIDEO' && pv.hasAttribute('data-media-id')) park(pv);
          } else if (n.querySelectorAll) {
            var list = n.querySelectorAll(SEL);
            for (var k = 0; k < list.length; k++) park(list[k]);
          }
        }
      }
    });
    parkObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- Phase 2: three independent wake triggers ---- */
  function arm() {
    var vids = document.querySelectorAll(SEL);
    if (!vids.length) return;

    for (var i = 0; i < vids.length; i++) park(vids[i]);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) {
            io.unobserve(entries[e].target);
            wake(entries[e].target);
          }
        }
      }, { rootMargin: '150px' });
      for (var m = 0; m < vids.length; m++) io.observe(vids[m]);
    } else {
      for (var f = 0; f < vids.length; f++) wake(vids[f]);
      return;
    }

    for (var s = 0; s < vids.length; s++) {
      (function (v) {
        var slide = v.closest ? v.closest('.swiper-slide') : null;
        if (!slide) return;

        if (ACTIVE.test(slide.className)) { wake(v); return; }

        if (typeof MutationObserver === 'function') {
          var classObserver = new MutationObserver(function () {
            if (ACTIVE.test(slide.className)) {
              classObserver.disconnect();
              wake(v);
            }
          });
          classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
        }

        var onPoke = function () {
          slide.removeEventListener('pointerdown', onPoke);
          slide.removeEventListener('click', onPoke);
          slide.removeEventListener('touchstart', onPoke);
          wake(v);
        };
        slide.addEventListener('pointerdown', onPoke, { passive: true });
        slide.addEventListener('click', onPoke, { passive: true });
        slide.addEventListener('touchstart', onPoke, { passive: true });
      })(vids[s]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
  window.addEventListener('load', arm);
})();
